import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

import { cn } from '../../lib/cn';

const badgeVariants = cva(
	'inline-flex items-center rounded-[11px] border px-1.5 py-0.5 font-mono text-[11px] font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 whitespace-nowrap',
	{
		variants: {
			variant: {
				default: 'border-accent/20 bg-accent/10 text-accent',
				secondary: 'border-border bg-card text-text-muted',
				destructive: 'border-destructive/30 bg-destructive/15 text-destructive',
				outline: 'border-border text-foreground',
				green: 'border-accent-green/30 bg-accent-green/15 text-accent-green',
				orange: 'border-warn/30 bg-warn/15 text-warn',
				purple: 'border-accent-purple/30 bg-accent-purple/15 text-accent-purple',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
	/** Stile visivo del badge (colore/accento). Default: `default`. */
	variant?: VariantProps<typeof badgeVariants>['variant'];
}

/** Etichetta compatta per stati, categorie o conteggi (es. stato pratica, tag). */
function Badge({ className, variant, ...props }: BadgeProps) {
	return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
